/**
 * API Error Handler
 * -----------------
 *  • Extracts any structured payload the backend returns
 *  • Preserves your EMAIL_NOT_VERIFIED flow
 *  • Falls back gracefully when there is no response (network error, timeout)
 */

import axios from "axios";

export const handleApiError = (error) => {
  // 1. Network / unexpected error: nothing we can parse
  if (!axios.isAxiosError(error) || !error.response) {
    console.error(error);
    return error; // generic Error instance
  }

  const { status, data } = error.response;

  // 2. Your custom 403 logic (unchanged)
  if (status === 403 && data?.detail?.code === "EMAIL_NOT_VERIFIED") {
    const e = new Error(data.detail.message || "Email not verified");
    e.code = "EMAIL_NOT_VERIFIED";
    e.status = 403;
    return e;
  }

  // 3. Any other backend payload: forward it exactly as we got it
  //    FastAPI helper returns { success:false, message:'Bad request', errors:{…} }
  if (data && typeof data === "object") {
    return data;
  }

  // 4. Fallback when backend gave plain text or no body
  const e = new Error(error.message || "An error occurred");
  e.status = status;
  return e;
};
